import React from 'react';

import Team from '../Team';
import UserBar from '../UserBar';
import Menu from '../Menu';
import MobileMenu from '../MobileMenu';
import ChatContainer from '../../chat';

export default function BmcCanvasContainer({
  children,
  locales,
  withChat = false,
}) {
  return (
    <div className="bmc-canvas-container">
      <Menu locales={locales} />
      <MobileMenu locales={locales} />

      <div className="bmc-canvas-container-block">
        <nav className="bmc-canvas-container-block-top" aria-label="Top bar">
          <Team locales={locales} />
          <UserBar locales={locales} />
        </nav>
        {withChat ? (
          <main className="bmc-canvas-container-block-section">
            <section
              className="bmc-canvas-container-block-section__chat"
              aria-label="Messaging"
            >
              <ChatContainer />
            </section>
            <section
              className="bmc-canvas-container-block-section__content"
              aria-label="Portfolio"
            >
              <div className="bmc-canvas-container-block-content">
                {children}
              </div>
            </section>
          </main>
        ) : (
          <main className="bmc-canvas-container-block-content">
            <div style={{ width: '100%' }}>{children}</div>
          </main>
        )}
      </div>
    </div>
  );
}
